class FontFace {
  constructor(family, source) {
    this.family = family;
    this.source = source;
  }
}

module.exports = FontFace;